import React, { useEffect, useRef } from 'react';
import { toast } from 'sonner';
import { CONSTANTS } from '../utils/constants';
const names = [{
  name: 'Carlos M.',
  city: 'Buenos Aires'
}, {
  name: 'Martín R.',
  city: 'Córdoba'
}, {
  name: 'Diego F.',
  city: 'Rosario'
}, {
  name: 'Lucas S.',
  city: 'Mendoza'
}, {
  name: 'Pablo T.',
  city: 'La Plata'
}, {
  name: 'Javier L.',
  city: 'Mar del Plata'
}, {
  name: 'Sebastián G.',
  city: 'Salta'
}, {
  name: 'Fernando P.',
  city: 'Tucumán'
}, {
  name: 'Matías V.',
  city: 'Santa Fe'
}, {
  name: 'Alejandro C.',
  city: 'Neuquén'
}, {
  name: 'Ricardo B.',
  city: 'San Juan'
}, {
  name: 'Gustavo H.',
  city: 'Paraná'
}];
export const PurchasePopup: React.FC = () => {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    const showPopup = () => {
      const randomPerson = names[Math.floor(Math.random() * names.length)];
      toast(<div className="flex items-center gap-3" data-id="element-234">
          <img src={CONSTANTS.IMAGES.MAIN_PRODUCT} alt="Product" className="w-12 h-12 rounded object-cover" data-id="element-235" />
          <div data-id="element-236">
            <p className="font-bold text-sm" data-id="element-237">
              {randomPerson.name} de {randomPerson.city}
            </p>
            <p className="text-xs text-gray-600" data-id="element-238">
              Acaba de comprar este producto
            </p>
          </div>
        </div>, {
        duration: 4000,
        position: 'bottom-left'
      });
    };
    const initialTimeout = setTimeout(() => {
      showPopup();
      intervalRef.current = setInterval(() => {
        showPopup();
      }, Math.random() * 15000 + 15000);
    }, 10000);
    return () => {
      clearTimeout(initialTimeout);
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);
  return null;
};